import { INTEGRATION_LIB_ERROR } from 'groverPaymentSDK';

export default function getTkForPaymentLibraryError(errorType) {
    switch (errorType) {
        case INTEGRATION_LIB_ERROR.GENERAL:
            return 'CREDIT_CARD_FORM_ERROR_GENERAL';
        case INTEGRATION_LIB_ERROR.INVALID_CARD_NUMBER:
            return 'CREDIT_CARD_FORM_ERROR_INVALID_CARD_NUMBER';
        case INTEGRATION_LIB_ERROR.INVALID_CARD_CVV:
            return 'CREDIT_CARD_FORM_ERROR_INVALID_CARD_CVV';
        case INTEGRATION_LIB_ERROR.INVALID_CARD_EXPIRATION:
            return 'CREDIT_CARD_FORM_ERROR_INVALID_CARD_EXPIRATION';
        case INTEGRATION_LIB_ERROR.INVALID_CARDHOLDER:
            return 'CREDIT_CARD_FORM_ERROR_INVALID_CARDHOLDER';
        case INTEGRATION_LIB_ERROR.CARD_EXPIRED:
            return 'CREDIT_CARD_FORM_ERROR_CARD_EXPIRED';
        default:
            return 'CREDIT_CARD_FORM_ERROR_GENERAL';
    }
}
